export var OptionsProfiles = [{ value: 'circulando', label: 'Circulando' }, { value: 'parado', label: 'Parado' }, { value: 'estacionado', label: 'Estacionado' },
// { value: 'noGPS', label: 'No-GPS' },
{ value: 'noGPRS', label: 'No-GPRS' }];